/**
 * Web Crypto `getRandomValues` の名前付きラッパ。
 *
 * 意図を明示した関数名で呼び出し側のミスを防ぐ。
 * すべての関数は `crypto.getRandomValues` に委譲するだけで、
 * 暗号処理は行わない。
 *
 * 参照: KEY_HIERARCHY.md §5 (各素材のサイズ定義)
 */
import { AES_GCM, ARGON2 } from './constants'

const getRandomValues = (n: number): Uint8Array => {
  if (!Number.isInteger(n) || n <= 0) {
    throw new RangeError(`randomBytes: byte count must be a positive integer, got ${n}`)
  }
  const buf = new Uint8Array(n)

  globalThis.crypto.getRandomValues(buf)

  return buf
}

/** n byte のランダムバッファを返す汎用ヘルパ。 */
export const randomBytes = (n: number): Uint8Array => getRandomValues(n)

/**
 * AES-GCM 鍵 (32 byte) 相当の乱数バッファを返す。
 * Symmetric Key (SK) の初期生成用 (KEY_HIERARCHY.md §4.1 step 5)。
 */
export const randomKeyBytes = (): Uint8Array => getRandomValues(AES_GCM.KEY_BYTES)

/**
 * AES-GCM IV (12 byte) を生成する。
 * 毎回新規生成し、再利用禁止 (KEY_HIERARCHY.md §5)。
 */
export const randomIvBytes = (): Uint8Array => getRandomValues(AES_GCM.IV_BYTES)

/**
 * KDF salt (16 byte) を生成する。
 * 登録時の kdfSalt として使用 (KEY_HIERARCHY.md §4.1 step 2)。
 */
export const randomSaltBytes = (): Uint8Array => getRandomValues(ARGON2.DEFAULT_SALT_BYTES)
